import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-36995196-35',
  router
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
